import { Divider, Typography } from 'antd'
import React from 'react'
import BinOutward from '../../../components/Wash/BinOutward/BinOutward'

const BinOutwardPage = ({userData}) => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography.Title
          level={5}
          style={{
            margin: 0,
          }}
        >
          Bin Outward
        </Typography.Title>
      </div>
      <Divider style={{ marginTop: 8 }} />
      <BinOutward userData={userData} />
    </>
  )
}

export default BinOutwardPage